import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-empty-space',
  templateUrl: './empty-space.component.html',
  styleUrls: ['./empty-space.component.scss']
})
export class EmptySpaceComponent implements OnInit {
  @Output() createSpaceClickedEmit = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  createSpaceClicked() {
    this.createSpaceClickedEmit.emit(true);
  }

}
